import {Injectable} from '@angular/core';
import {StorageService} from 'src/app/core/services/storage.service';
import {ALLOW_COOKIES_LOCAL_STORAGE_KEY, FB_PIXEL_KEY, LANG_KEY_LOCAL_STORAGE_KEY} from 'src/app/app.constants';
import {CookieSettingsModel} from '../models/cookieSettings.model';
import {CookieTypesEnum} from '../enums/cookie-types.enum';
import {TranslateService} from '@ngx-translate/core';
import {CookieService} from 'ngx-cookie-service';
import {PixelService} from './pixel.service';
import {capitalize} from '../../core/utils/strings.util';
import * as gtag from 'src/app/core/utils/gtag';
import {HubspotService} from '../../core/services/hubspot.service';

@Injectable({providedIn: 'root'})
export class AppService {

    private domain = '.' + window.location.hostname;

    constructor(private storageService: StorageService,
                private translateService: TranslateService, private cookieService: CookieService,
                private pixelService: PixelService,
                private hubspotService: HubspotService) {
    }

    getCookiesAllowed(): CookieSettingsModel {
        const cookie = this.storageService.get(ALLOW_COOKIES_LOCAL_STORAGE_KEY);
        if (!!cookie) {
            if (!cookie.hasOwnProperty('cookieVersion') || cookie.cookieVersion !== CookieSettingsModel.version) {
                return null;
            }
        }
        return cookie;
    }

    allowCookies(cookieSettings: CookieSettingsModel) {
        this.storageService.save(ALLOW_COOKIES_LOCAL_STORAGE_KEY, cookieSettings);
    }

    isCookieIsAllowed(cookieType: CookieTypesEnum) {
        const cookieSettings = this.storageService.get(ALLOW_COOKIES_LOCAL_STORAGE_KEY);
        return cookieSettings ? cookieSettings[`allow${capitalize(cookieType.toString())}`] : false;
    }

    reprocessCookie() {
        const cookieSettings = this.getCookiesAllowed();
        if (cookieSettings.allowPreferences) {
            if (!this.storageService.get(LANG_KEY_LOCAL_STORAGE_KEY)) {
                this.storageService.save(LANG_KEY_LOCAL_STORAGE_KEY, this.translateService.currentLang);
            }
        } else {
            this.storageService.remove(LANG_KEY_LOCAL_STORAGE_KEY);
        }
        if (cookieSettings.allowAnalytics) {
            // Google analytics
            gtag.start();
            // fb pixel
            this.pixelService.init(FB_PIXEL_KEY);
            // Starting hubspot
            this.hubspotService.start();
            // For Safari browser the cookies changes need browser refresh/reload
            window.location.reload();
        } else {
            // Google analytics
            gtag.stop();
            // fb pixel
            this.pixelService.stop();
            // hubspot
            this.hubspotService.stop();

            // Remove cookies
            this.cookieService.delete('_fbp', '/', this.domain);
            this.cookieService.delete('_ga_YFMDH3G8KT', '/', this.domain);
            this.cookieService.delete('_ga', '/', this.domain);
            this.cookieService.delete('__hstc', '/', this.domain);
            this.cookieService.delete('_hubspotutk', '/', this.domain);
            this.cookieService.delete('hubspotutk', '/', this.domain);
            this.cookieService.delete('__hssrc', '/', this.domain);
            this.cookieService.delete('__hssc', '/', this.domain);

            window.location.reload();
        }
    }
}
